import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { BubbleData, EffectBackgroundProps } from '../types'

export const FloatingBubblesEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const bubbleColor = effectColors[0] || '#6366f1'

  const [bubbles] = useState(() => {
    const bubbleCount = 10
    const newBubbles: Array<BubbleData> = []
    for (let i = 0; i < bubbleCount; i++) {
      newBubbles.push({
        id: i,
        x: Math.random() * 100,
        size: 50 + Math.random() * 100,
        duration: 8 + Math.random() * 8,
        delay: Math.random() * 5,
      })
    }
    return newBubbles
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {bubbles.map((bubble) => (
        <motion.div
          key={bubble.id}
          style={{
            position: 'absolute',
            width: `${bubble.size}px`,
            height: `${bubble.size}px`,
            left: `${bubble.x}%`,
            background: `radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.3), ${bubbleColor})`,
            border: `1px solid rgba(255, 255, 255, 0.3)`,
            backdropFilter: 'blur(10px)',
            boxShadow: `inset 0 0 20px rgba(255, 255, 255, 0.2), 0 0 20px ${bubbleColor}40`,
            opacity: opacityValue,
            borderRadius: '50%',
          }}
          initial={{
            bottom: '-20%',
            rotate: 0,
          }}
          animate={{
            bottom: '120%',
            rotate: 360,
            x: [0, 30, -30, 0],
          }}
          transition={{
            duration: bubble.duration * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'linear',
            delay: bubble.delay,
            x: {
              duration: (bubble.duration / 2) * (100 / Math.max(effectSpeed, 1)),
              repeat: Infinity,
              ease: 'easeInOut',
            },
          }}
        />
      ))}
    </div>
  )
})
FloatingBubblesEffect.displayName = 'FloatingBubblesEffect'
